import React from "react";
import { useLoaderData } from "react-router-dom";
import NewsSummaryCard from "../../Shared/NewsSummaryCard/NewsSummaryCard";

const Home = () => {
   const allNews = useLoaderData();
   return (
      <div>
         <h2>Home : {allNews.length}</h2>
         {allNews.map((news) => (
            <NewsSummaryCard key={news._id} news={news} />
         ))}
      </div>
   );
};

export default Home;
